export class NewBillItem {
    operationState="i";
    idBillItem:number;
    idBillmaster:number;
    productDescription:string;
    productGST:number;
    productHSN:string;
    productQty:number=1;
    productRate:number;
    productToalGSTAmount:number;
    productTotalAmount:number;
    productSerialNumber:string;
    

}